// extracted by mini-css-extract-plugin
export default {"hotEvent":"hot-list_hotEvent__5ygMx"};